import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
export function QuickWins() {
  return <section className="w-full bg-[#fff] py-20 px-4" data-id="element-305">
      <div className="max-w-[680px] mx-auto" data-id="element-306">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-307">
          <h2 className="font-serif text-3xl md:text-4xl text-[#0f172a] mb-8 text-center" data-id="element-308">
            Lo Que Podrías Notar Rápido
          </h2>
          <p className="text-center text-[#64748b] mb-10" data-id="element-309">
            (sin promesas mágicas)
          </p>

          <ul className="space-y-4 mb-12" data-id="element-310">
            {['Menos "¿qué hago?"', 'Menos decisiones contradictorias', 'Menos estimulación accidental', 'Más sensación de control', 'Noches menos eternas, incluso si tu bebé sigue despertando'].map((item, i) => <motion.li key={i} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-center gap-3 text-lg text-[#334155] bg-[#faf7f2] p-4 rounded-lg" data-id="element-311">
                <Sparkles className="w-5 h-5 text-[#e8856c]" data-id="element-312" />
                {item}
              </motion.li>)}
          </ul>

          <div className="text-center bg-[#f0f9ff] p-8 rounded-xl border border-[#e0f2fe]" data-id="element-313">
            <p className="text-[#0369a1] mb-2 font-medium" data-id="element-314">
              Porque la primera victoria no es "que duerma 10 horas".
            </p>
            <p className="font-serif text-2xl text-[#0c4a6e] font-bold" data-id="element-315">
              La primera victoria es: <br data-id="element-316" />
              que tú no colapses cada despertar.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}